<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/loud/loud',title:'信息漏斗'},{title:'链群交互'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="选择日期" style="width: 50%;">
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.timeB"
										:clearable="false"
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.timeE"
										:clearable="false"
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item label="链群">
							    <brselect
							            style="width:100%;"
							            category="gh_lianqun"
							            :v="formInline.chainGroup"
							            v-model="formInline.chainGroup"
							            clearable
							            placeholder="--请选择--">
							    </brselect>
							</el-form-item>
							<el-form-item label="节点">
							    <brselect
							            style="width:100%;"
							            category="xinxi_jiedian"
							            :v="formInline.statusR"
							            v-model="formInline.statusR"
							            clearable>
							    </brselect>
							</el-form-item>
						</div>	
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
                            @cell-click="changecell"
                            :summary-method="getSummaries"
                            show-summary
                            style="width: 100%"
							max-height="600">
							<el-table-column
							type="selection"
							width="50"
							fixed
							>
							</el-table-column>
							<el-table-column
							    type="index"
							    width="40"
							    label="#"
								fixed
							    >
							 </el-table-column>
                        <el-table-column
                                prop="code"
								width="100"
                                label="链群"
								 :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="gh_lianqun" :v="scope.row.code"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="node1"
                                :label="nodeName1"
								 :show-overflow-tooltip="true">
								 <template scope="scope">
								 	<div style="text-align: right;">
								 		{{scope.row.node1}}
								 	</div>
								 </template>
                        </el-table-column>
                        <el-table-column
                                prop="node2"
                                :label="nodeName2"
								 :show-overflow-tooltip="true">
								 <template scope="scope">
								 	<div style="text-align: right;">
								 		{{scope.row.node2}}
								 	</div>
								 </template>
                        </el-table-column>
                        <el-table-column
                                prop="node3"
                                :label="nodeName3"
								 :show-overflow-tooltip="true">
								 <template scope="scope">
								 	<div style="text-align: right;">
								 		{{scope.row.node3}}
								 	</div>
								 </template>
                        </el-table-column>
                        <el-table-column
                                prop="node4"
                                :label="nodeName4"
								 :show-overflow-tooltip="true">
								 <template scope="scope">
								 	<div style="text-align: right;">
								 		{{scope.row.node4}}
								 	</div>
								 </template>
                        </el-table-column>
                        <el-table-column
                                prop="node5"
                                :label="nodeName5"
                                :show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.node5}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="node6"
                                :label="nodeName6"
                                :show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.node6}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="node7"
                                :label="nodeName7"
                                :show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.node7}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="node8"
                                :label="nodeName8"
                                :show-overflow-tooltip="true">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.node8}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="total"
								width="100"
                                label="合计(万元)">
								<template scope="scope">
									<div style="text-align: right;">
										{{scope.row.total}}
									</div>
								</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                </div>
            </div>
        </div>
        <el-dialog
                title=""
                :visible.sync="dialogVisible"
                :fullscreen="false"
                width="50%"
                :modal="true"
                :before-close="handleClose">
            <div class="tanBox">
                <el-table
                        :data="tableDatas"
                        @selection-change="handleSelectionChange"
                		max-height="420"
						border
                        style="width: 100%">
                    <el-table-column
                            type="selection"
                            width="45">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            width="180"
                            :show-overflow-tooltip="true">
                			<template slot-scope="scope">
                				<div style="text-align: left;">{{scope.row.projectName}}</div>
                			</template>
                    </el-table-column>
                    <el-table-column
                            prop="statusR"
                            label="节点"
                            width="100"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="xinxi_jiedian"  :v="scope.row.statusR"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="最后更新时间"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="expectConvertDate"
                            label="报单日期"
                            width="100"
                            value-format="yyyy-MM-dd"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="expConvDate"
                            label="预计成单日期"
                            width="120"
                            value-format="yyyy-MM-dd"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="area"
                            label="区域"
							width="80"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="YLRegion"  :v="scope.row.area"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="chainGroup"
                            label="链群"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="gh_lianqun"  :v="scope.row.chainGroup"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="customerChannel"
                            label="渠道"
                            width="80"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="loud_region"  :v="scope.row.customerChannel"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="partner"
                            label="合伙人名称"
                            width="180"
                            :show-overflow-tooltip="true">
                			<template slot-scope="scope">
                				<div style="text-align: left;">{{scope.row.partner}}</div>
                			</template>
                    </el-table-column>
                    <el-table-column label="用户信息">
                        <el-table-column
                                prop="customerName"
                                label="用户单位"
                                width="180"
                                :show-overflow-tooltip="true">
                				<template slot-scope="scope">
                					<div style="text-align: left;">{{scope.row.customerName}}</div>
                				</template>
                        </el-table-column>
                        <el-table-column
                                prop="deptName"
                                label="部门/科室"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="chargePerson"
                                label="负责人"
                                width="80"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="phone"
                                label="电话"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="产品信息">
                        <el-table-column
                                prop="productModel"
                                label="产品型号"
                                width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                label="数量"
                                width="60"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="price"
                                label="价格(万元)"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="totalValue"
                                label="合计(万元)"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="中/丢标分析">
                        <el-table-column
                                prop="dbBrand"
                                label="中标品牌"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="dbTotalValue"
                                label="中/丢标总额"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="dbReason"
                                label="丢标原因"
                                width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table-column>
                    <el-table-column
                            prop="merchandier"
                            label="跟单商类别"
                            width="110"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="gendanshang"  :v="scope.row.merchandier"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="supplement"
                            label="是否挂网补录"
                            width="120"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="shifou_keyong"  :v="scope.row.supplement"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="whetherContactor"
                            label="是否城市网"
                            width="110"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="chengshi_wang"  :v="scope.row.whetherContactor"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="messageType"
                            label="信息类别"
                            width="90"
                            :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <dictname category="message_type"  :v="scope.row.messageType"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注"
                            width="180"
                            :show-overflow-tooltip="true">
                			<template slot-scope="scope">
                				<div style="text-align: left;">{{scope.row.remark}}</div>
                			</template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="display:flex;justify-content: space-between;align-items:center;margin-top:0.2rem">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportMsgExcel">批量导出
                </el-button>
                <paginationmin :page="formInline" @query="handlefanye"/>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import big from 'big.js'
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile';

    export default {
        data() {
            return {
                tableDatas:[],
                dialogVisible:false,
                objectlists: [],
                multipleSelection: [],
                formInline: {
                    timeB: '',
                    timeE: '',
                    chainGroup: '',
                    statusR: '',
                    hang: '',
                    lie: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                nodeName1: '',
                nodeName2: '',
                nodeName3: '',
                nodeName4: '',
                nodeName5: '',
                nodeName6: '',
                nodeName7: '',
                nodeName8: '',
                tableData: [],
            }
        },
        mounted() {

        },
        created() {
            this.showJD();
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            exportMsgExcel() {
                var idlist=[];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/loudProduct/downloadExcel",idlist,"post",'data');
            },
            changecell(row, column, cell, event){
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.formInline.hang = row.code;
                this.formInline.lie = column.label;
                ss.loud.selectGroupMutualPage(this.formInline).then(rd => {
                    this.tableDatas = rd.records;
                    this.formInline.total = rd.total;
                    this.dialogVisible = true;
                })
            },
            handlefanye() {
                ss.loud.selectGroupMutualPage(this.formInline).then(rd => {
                    this.tableDatas = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            //关闭弹出框
            handleClose(v) {
                v()
            },
            //明细导出
            exportExcel() {
                var ids=[];
                for (var j = 0; j < this.tableData.length; j++) {
                    ids.push(this.tableData[j]);
                }
                updownfile.down("/api/swyl/v1/demo/loudProduct/downloadowGroupMutualExcel",ids,"post",'data');
            },
            handleFilter() {
                // var timeB = this.formInline.timeB;
                // var timeE = this.formInline.timeE;
                ss.cpjh.showProduct(this.formInline).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.setItemDate(this.tableData[i])
                    }
                    this.sumNum();
                })
            },
            resetData() {
                this.formInline.timeB = '';
                this.formInline.timeE = '';
                this.formInline.chainGroup = '';
                this.formInline.statusR = '';
                this.query();
            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return (new big(prev).plus(curr)).toFixed(2);
                            } else {
                                return prev;
                            }
                        }, 0);
						sums[2] = '';
                    } else {
                        sums[1] = '';
                    }
                });

                return sums;
            },
            query() {
                // var timeB = this.formInline.timeB;
                // var timeE = this.formInline.timeE;
                ss.cpjh.showProduct(this.formInline).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        // this.setItemDate(this.tableData[i])
                        for (var j = 0; j < this.objectlists.length; j++) {
                            var ol = this.objectlists[j];
                            this.tableData[i]['node' + (j + 1)] = this.tableData[i].map[ol] || null;
                        }
                    }
                    this.sumNum();
                })
            },
            showJD() {
                ss.cpjh.showJD().then(rd => {
                    rd.forEach((item, index) => {
                        this['nodeName' + (index + 1)] = item;
                        this.objectlists.push(item);
                    })
                })
                this.query();
            },
            setItemDate(obj) {
                for (var j = 0; j < this.objectlists.length; j++) {
                    var ol = this.objectlists[j];
                    obj['node' + (j + 1)] = obj.map[ol] || null;
                }
            },
            sumNum(){
                this.tableData.forEach((item, index) => {
                    let tot = 0;
                    for (var i=0 ; i<8 ; i++) {
                        tot = new big(tot).plus(item['node' + (i + 1)] || 0);
                    }
                    item.total = tot.toFixed(2);
                })
            }
        }
    }
</script>
<style>
    .tanBox .el-table thead.is-group th{
        background:#57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
</style>